export const getRewardStatus = (reward, currentPoints) => {
  if(reward.cost <= currentPoints) {
      return "unlocked"
  } else {
      return "locked"
  }
};